import { render, staticRenderFns } from "./user-form.vue?vue&type=template&id=46ec02e8&scoped=true"
import script from "./user-form.vue?vue&type=script&lang=js"
export * from "./user-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec02e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ec02e8')) {
      api.createRecord('46ec02e8', component.options)
    } else {
      api.reload('46ec02e8', component.options)
    }
    module.hot.accept("./user-form.vue?vue&type=template&id=46ec02e8&scoped=true", function () {
      api.rerender('46ec02e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/user/components/user-form.vue"
export default component.exports